export default __webpack_public_path__ + "static/media/gold-lock.280376ff.svg";